// --------------------------------------------------------------------------
// closeAlert.js
// --------------------------------------------------------------------------
// Closes and hides a visible alert
// --------------------------------------------------------------------------

RN.closeAlert = function() {

  'use strict';

  function init() {
    byBehaviour('close-alert').on('click', closeAlert);
  }

  function closeAlert() {

    // set cookie
    if($(this).data("closed-message") == 1) {
      document.cookie = "closedClosedMessage=1; path=/";
    }

    var alert = $(this).closest('.alert');
    alert.addClass('alert--removing');

    setTimeout(function(){
        alert.slideUp(250, function(){
            alert.remove(); 
        });
    }, 50);
  }

  return {
    init: init
  };

}();